import { useState } from 'react';
import { Star } from 'lucide-react';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';

export const ReviewForm = ({ onSubmit, isSubmitting = false }) => {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [text, setText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating === 0 || text.trim() === '') return;
    onSubmit({ rating, text: text.trim() });
    setRating(0);
    setText('');
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="review-form">
      {/* Star Rating */}
      <div>
        <label className="block text-sm font-medium text-gray-400 mb-2">
          Your Rating
        </label>
        <div className="flex items-center gap-1">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              type="button"
              onClick={() => setRating(star)}
              onMouseEnter={() => setHoveredRating(star)}
              onMouseLeave={() => setHoveredRating(0)}
              className="p-1 transition-transform hover:scale-110"
              data-testid={`star-${star}`}
            >
              <Star
                className={`w-8 h-8 transition-colors ${
                  star <= (hoveredRating || rating)
                    ? 'text-yellow-400 fill-yellow-400'
                    : 'text-gray-600'
                }`}
              />
            </button>
          ))}
        </div>
      </div>

      {/* Review Text */}
      <div>
        <label className="block text-sm font-medium text-gray-400 mb-2">
          Your Review
        </label>
        <Textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Share your experience with this trainer..."
          className="min-h-[100px] bg-[#1A1A1A] border-transparent text-white placeholder:text-gray-500 focus:ring-2 focus:ring-primary focus:border-transparent rounded-xl resize-none"
          data-testid="review-text"
        />
      </div>

      {/* Submit Button */}
      <Button
        type="submit"
        disabled={rating === 0 || text.trim() === '' || isSubmitting}
        className="w-full bg-primary text-white font-bold uppercase tracking-wider py-4 rounded-xl hover:shadow-[0_0_30px_rgba(59,130,246,0.6)] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid="submit-review-button"
      >
        {isSubmitting ? 'Submitting...' : 'Submit Review'}
      </Button>
    </form>
  );
};
